import React from 'react';
import PropTypes from 'prop-types';
import {Paper} from "material-ui";
import Subheader from 'material-ui/Subheader';
import {connect} from "react-redux";
import Error from "../../../components/common/Error/Error";
import Loading from "../../../components/common/Loading/Loading";
import {fetchApp} from '../../../store/apps/actions';
import style from '../../../styles/styles';
import styles from './EditTrailPage.css';
import {fetchTrail, putTrail} from "../../../store/trails/actions";
import TrailForm from "../../../components/openexplore/TrailForm/TrailForm";
import {getTypes} from "../../../store/types/actions";
import {getCustomFields} from "../../../store/customfields/actions";
import CustomFieldService from '../../../services/customfield';
import {TRAIL_PAGE} from "../../../constants/routes";

export class EditTrailPage extends React.Component {

    static propTypes = {
        app: PropTypes.object
    };

    static defaultProps = {};

    state = {
        latlng: null
    };

    componentWillMount() {
        this.fetch();

        if (this.props.app) {
            this.props.getTypes(this.props.app.id, this.props.lang);
            this.props.getCustomFields(this.props.app.id);
        }
    }

    componentWillUpdate(nextProps) {
        if (this.props.sending && !nextProps.sending) {
            let url = TRAIL_PAGE
                .replace(':appId', this.props.app.id)
                .replace(':trailId', this.props.trail.id);
            this.props.history.push(url);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.app && this.props.app !== nextProps.app) {
            this.props.getTypes(nextProps.app.id, nextProps.lang);
            this.props.getCustomFields(nextProps.app.id);
        }
    }

    // Fetch

    fetch(appId = null, trailId = null) {
        this.fetchApplication(appId);
        this.fetchTrail(appId, trailId);
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id)
            }
        }
    }

    fetchTrail(appId = null, trailId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const trail = trailId || this.props.match.params.trailId;

            if (app && trail) {
                this.props.fetchTrail(app, trail, this.props.lang)
            }
        }
    }

    // Actions

    handleFormSubmit = async (formProps) => {
        await this.props.putTrail(this.props.app.id, formProps, this.props.lang);
    };

    // Render

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.trail) {
            return <Loading paper={false}/>;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>Trail / Edit</h3>
                    <div className="row">
                        <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">

                            <Paper style={styles.editBox}>
                                <Subheader style={style.subHeader}>{this.props.trail.name}</Subheader>
                                <div style={style.paper}>
                                    <TrailForm
                                        customFields={CustomFieldService.filter(this.props.customFields, CustomFieldService.OPEN_EXPLORE_TRAIL)}
                                        types={this.props.types}
                                        onSubmit={this.handleFormSubmit}
                                        initialValues={this.props.initialValues}
                                        submitting={this.props.sending}
                                        trail={this.props.trail}
                                        enableReinitialize={true}
                                    />
                                </div>
                                <div style={style.clear}/>
                            </Paper>
                        </div>
                    </div>
                </div>
            )
        }
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        loading: state.apps.pending || state.trails.pending || state.types.pending,
        error: state.trails.error || state.apps.error,
        trail: state.trails.currentTrail,
        lang: state.ui.currentLang,
        app: state.apps.currentApplication,
        sending: state.trails.sending,
        mapStyle: state.ui.mapStyle,
        types: state.types.content,
        typesPending: state.types.pending,
        customFields: state.customFields.content
    };

    const trail = state.trails.currentTrail;
    if (trail) {
        let initValues = {...trail};
        if (trail.custom_fields) {
            trail.custom_fields.forEach((customField) => {
                initValues[customField.id] = customField.value;
            });
        }
        props.initialValues = initValues;
    }

    return props;
}

export default connect(mapStateToProps, {
    getTypes,
    getCustomFields,
    putTrail,
    fetchApp,
    fetchTrail
})(EditTrailPage);



// WEBPACK FOOTER //
// src/containers/openexplore/EditTrailPage/EditTrailPage.js